module.exports = __webpack_public_path__ + "themes/mf/img/background.jpg";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/background.jpg
// module id = 67
// module chunks = 3